import React from "react";
import "./Spinner.css"; // Importing CSS for styling

const Spinner = ({ color = "#dca914", isLive = false, inline = false }) => {
  // Use red color for live videos, otherwise use provided color
  const spinnerColor = isLive ? "#ff0000" : color;
  
  // If inline, don't use the full-screen container
  if (inline) {
    return (
      <div 
        className="spinner"
        style={{
          borderTopColor: spinnerColor,
          borderLeftColor: spinnerColor,
          borderRightColor: spinnerColor,
          '--spinner-color': spinnerColor,
        }}
      >
      </div>
    );
  }
  
  return (
    <div className="spinner-container">
      <div 
        className="spinner"
        style={{
          borderTopColor: spinnerColor,
          borderLeftColor: spinnerColor,
          borderRightColor: spinnerColor,
          '--spinner-color': spinnerColor,
        }}
      >
      </div>
    </div>
  );
};

export default Spinner;
